module.exports = __webpack_public_path__ + "static/media/history.a358d8de.svg";